import { createApp } from 'vue'
// 引入组件库的少量全局样式变量
import 'tdesign-vue-next/es/style/index.css';
import router from './router'
import axios from 'axios'
import pinia from './pinia/store'
import Vant from 'vant';
import '~/styles/index.scss'
import '../src/styles/theme.css'
// 引入样式
import "@easytable/vue/libs/theme-default/index.css";
// 引入组件库
import { useVeTable } from "@easytable/vue";
import 'element-plus/dist/index.css'
import 'vant/lib/index.css';

import * as echarts from 'echarts'
import VChart from 'vue-echarts'

import App from './App.vue'
import VueGtag from "vue-gtag";
import { initAnalytics } from './utils/analytics.js';
import { jobSyncChecker } from './utils/job-sync-checker.js';
import { initWeCom } from './utils/wecom-jsapi.js';
import '@lark-base-open/js-sdk' 

const app = createApp(App);

// 初始化 Google Analytics
app.use(VueGtag, {
    config: {
        id: import.meta.env.VITE_GA_MEASUREMENT_ID,
        params: {
            send_page_view: false
        }
    },
    pageviewTracker: false
}, router);

app
    .use(pinia)
    .provide('$axios', axios)
    .provide('$jobSyncChecker', jobSyncChecker)
    .use(router)
    .use(useVeTable())
    .component('VChart', VChart)
    .use(Vant)
    .mount('#app');

// 延迟初始化 Analytics 工具，确保 VueGtag 完全加载
setTimeout(() => {
  const gtagInstance = app.config.globalProperties.$gtag;
  if (gtagInstance && typeof gtagInstance === 'function') {
    initAnalytics(gtagInstance);
  } else {
    console.warn('VueGtag instance not found, analytics may not work properly');
  }
}, 100);

// 路由守卫 - 检查职位同步列表
router.beforeEach((to, from, next) => {
    console.log('from.path: ', from.path);
    console.log('to.path: ', to.path);
    
    // 排除不需要检查的路由
    const excludeRoutes = ['/login', 
        '/global-guide', 
        '/success', 
        '/interviewer-examine', 
        '/interviewer-use-examine',
        '/electron-centre-synchronize-home',
        '/electron-centre-guacamole-home',
        '/electron-centre-batch-home',
        '/electron-centre-home',
        '/weCom-mobile-table',
        '/wechat-talents',
        '/lark-enterprise-entry',
        '/lark-enterprise-callback',
        '/remote-window-login',
        '/dingtalk-enterprise-entry',
        "/batch-hosting-demand",
        "/wechat-enterprise-entry",
        "/social-callback",
        "/wechat-browser"
    ]
    // if(to.path === '/' && !localStorage.getItem('token')){ 
    //     router.replace({ path: '/wechat-enterprise-entry' })
    //     return
    // }
    if (excludeRoutes.includes(to.path)) {
        console.log('跳过检查的路由:', to.path)
        next()
        return
    }

    // 初始化企业微信 JSAPI（如果是在企微环境中且已登录）
    const isWeChatEnv = /MicroMessenger/i.test(navigator.userAgent)
    const hasToken = localStorage.getItem('token')
    const thirdPartyAppType = localStorage.getItem('thirdPartyAppType')
    console.log('thirdPartyAppType: ', thirdPartyAppType);
    console.log('hasToken: ', hasToken);
    console.log('isWeChatEnv: ', isWeChatEnv);
    
    if (isWeChatEnv && hasToken && thirdPartyAppType === 'wechat_enterprise') {
        console.log('开始初始化企微 JSAPI')
        // 异步初始化企微 JSAPI，不阻塞路由跳转
        initWeCom({
            jsApiList: ['getExternalContact', 'selectEnterpriseContact'],
            onConfigSuccess: (result) => {
                console.log('企微 JSAPI 初始化成功', result)
            },
            onConfigFail: (result) => {
                console.warn('企微 JSAPI 初始化失败', result)
            }
        }).catch((error) => {
            console.error('企微 JSAPI 初始化错误:', error)
        })
    }

    console.log('开始检查职位同步列表...')
    // 使用 Promise 处理异步操作
    jobSyncChecker.checkJobSyncList({
        forceCheck: true 
    }).then((hasJobSyncData) => {
        // 如果没有数据且不是要跳转到global-guide
        if (!hasJobSyncData && to.path !== '/global-guide') {
            // MessagePlugin.info('职位同步列表为空，请先同步职位')
            //移除对话内容
            localStorage.removeItem('globalGuideMessages')
            next('/global-guide')
            return
        }
        // 如果有数据或已经是global-guide页面，继续正常路由
        next()
    }).catch((error) => {
        next() // 发生错误时继续正常路由
    })
});

// 自定义 google analytics 路由标题
router.afterEach((to, from) => {
    try {
        const gtagInstance = app.config.globalProperties.$gtag;
        if (gtagInstance && typeof gtagInstance.pageview === 'function') {
            gtagInstance.pageview({
                page_path: to.path,
                page_title: to.meta?.title || to.name || '未知页面',
                page_location: window.location.href
            });
        }
    } catch (error) {
        console.warn('Router gtag pageview failed:', error);
    }
});
